<template>
  <div v-if="this.$store.state.loggedIn" class="icon-container">
    <v-dialog  v-model="open" transition="dialog-bottom-transition" max-width="600">
      <template v-slot:activator="{ on, attrs }">
        <div class="clickable-region"  v-bind="attrs" v-on="on">
        <img class="icon" v-bind:src="require(`../../assets/sidebar/user.svg`)" alt="" color="primary" />
        </div>
      </template>
      <template>
        <v-card>
          <div class="card-container">
            <v-toolbar class="title" color="primary" dark>Change Password</v-toolbar>
            <div class="change-password-container">
              <v-form ref="form" v-model="isFormValid">
                <div class="password-container-1">
                  <v-text-field v-model="oldPassword" autocomplete="current-password" :type="showPassword ? 'text' : 'password'" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword" label="Old Password" :rules="passwordRules" hide-details="auto"></v-text-field>
                </div>
                <div class="password-container-2">
                  <v-text-field v-model="newPassword" autocomplete="new-password" :type="showNewPassword ? 'text' : 'password'" :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showNewPassword = !showNewPassword" label="New Password" :rules="passwordRules" hide-details="auto"></v-text-field>
                </div>
                <div class="password-container-3">
                  <v-text-field v-model="confirmPassword" autocomplete="new-password" :type="showNewPassword ? 'text' : 'password'" :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showNewPassword = !showNewPassword" label="Confirm New Password" :rules="confirmPasswordRules.concat(passwordConfirmationRule)" hide-details="auto"></v-text-field>
                </div>
                <div class="bottom-buttons">
                <v-btn @click="close" class="cancel-button" width="100px" height="38px"> Cancel </v-btn>
                <v-btn :disabled="!isFormValid || loading" :loading="loading" @click="submit" class="change-password-button white--text" color="#5774E7" width="200px" height="38px" type="submit"> Change Password </v-btn>
                </div>
              </v-form>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </div>
    <div class="icon-container" v-else></div>
</template>

<script>
import axios from "axios";

import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {},
  methods: {
    submit() {
      this.loading = true;

      const url = this.$store.state.serverURL + "/users/changepassword";
      const data = { oldPassword: this.oldPassword, newPassword: this.newPassword };

      axios
        .post(url, data, { withCredentials: true })
        .then((res) => {
          this.loading = false;
          this.$toast.success("Successfully reset password", { position: "bottom-right", timeout: 7500 });
          this.close();
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error(err.request.responseText, { position: "bottom-right", timeout: 7500 });
        });
    },
    close() {
      this.open = false;
    },
  },
  watch: {
    open() {
      if(this.$refs.form != null){
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    passwordConfirmationRule() {
      return () => this.newPassword === this.confirmPassword || "Password must match";
    },
  },
  data: () => ({
    loading: false,
    email: "",
    open: false,
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    isFormValid: true,
    showPassword: false,
    showNewPassword: false,
    passwordRules: [(value) => !!value || "Required."],
    confirmPasswordRules: [(v) => !!v || "Password is required"],
  }),
});
</script>

<style>


</style>
<style scoped>

.bottom-buttons{
  position: absolute;
  top: 320px;
  width: 470px;
  display: flex;
  justify-content:space-between;
}

.card-container {
  height: 380px;
}
.change-password-container {
  padding-left: 60px;
  padding-right: 60px;
  height:300px;
}

.title {
  font-size: 25px;
}
.icon-container {
  width: 100%;
  cursor: pointer;
  height: 60px;
}

.icon {
  width: 32px;
  height: 32px;
  margin-left: calc(50% - 32px / 2);
  margin-top: calc(50% - 32px );
}
.icon-container:hover {
  transition: 0.3s ease;
  background-color: var(--sidebar-item-hover);
}
.password-container-1 {
  position: absolute;
  width: 470px;
  top: 80px;
}
.password-container-2 {
  position: absolute;
  width: 470px;
  top: 155px;
}
.password-container-3 {
  position: absolute;
  width: 470px;
  top: 230px;
}

.buttons {
  position: absolute;
  top: 325px;
  right: 25px;
}
</style>
